class CountrySwitcher extends window.BAO.CustomElement() {
	constructor() {
		super();
		this.currentLocation = this.dataset.isoCode;
	}

	connectedCallback() {
		super.connectedCallback();
		this.initialize();
	}

	setupListeners() {
		super.setupListeners();
		this.handleOpen = this.handleOpen.bind(this);
		this.handleClose = this.handleClose.bind(this);

		this.externalEls.trigger.elements.forEach(trigger => {
			this.listeners.add(trigger, 'click', this.handleOpen);
		});

		this.listeners.add(this.els.modal.element, 'click', this.handleCloseOutside.bind(this));

		this.listeners.add(this.els.close.element, 'click', this.handleClose);
	}

	handleCloseOutside(evt) {
		if (evt.target !== this.els.modal.element) {
			return;
		}

		this.handleClose(evt);
	}

	initialize() {
		this.countryParam = this.getUrlCountryParam();

		if (this.countryParam !== null) {
			const countryCode = this.countryParam;
			window.localStorage.setItem(this.userLocationName, countryCode);

			return;
		}

		if (this.noLocationStored) {
			window.BAO.Utils.fetchJSON('/browsing_context_suggestions.json', {
				method: 'GET',
			}).then(res => {

				const suggested = res.detected_values.country.handle;
				const current = this.dataset.isoCode;

				if (suggested === current) {
					return;
				}

				this.handleOpen();
			});
		}

		const saved = window.localStorage.getItem(this.storageKey);

		if (saved !== null && saved !== this.currentLocation) {
			this.handleOpen();
		}
	}

	handleOpen() {
		this.els.modal.element.setAttribute('aria-hidden', false);
	}

	handleClose(ev) {
		ev.preventDefault();
		this.els.modal.element.setAttribute('aria-hidden', true);
	}

	getUrlCountryParam() {
		const params = new Proxy(new URLSearchParams(window.location.search), {
			get: (searchParams, prop) => searchParams.get(prop),
		});

		return params.country || null;
	}

	get storageKey() {
		return this.dataset.storageKey;
	}

	get noLocationStored() {
		return (
			window.localStorage.getItem(this.storageKey) == null ||
			(window.localStorage.getItem(this.storageKey) === undefined &&
				!window.Shopify.designMode)
		);
	}
}

// Define the custom element
if (!customElements.get('country-switcher')) {
	customElements.define('country-switcher', CountrySwitcher);
}
